module.exports = __webpack_public_path__ + "static/media/thumbs_up_inactive.97a91e2c.svg";